import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import { Context, useContext } from "./Context";
import MessageModal from "./components/MessageModal";
import MenuIcon from "@mui/icons-material/Menu";
import {
    Divider,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import InfoIcon from "@mui/icons-material/Info";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import { useTheme } from "@mui/material/styles";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import { ColorModeContext } from "./App";
import { URL, origin } from "./config";

function ResponsiveAppBar() {
    const [error, setError] = React.useState("");
    const { userName, auth } = useContext(Context);
    const [userInfo, setUserInfo] = React.useState();
    const navigate = useNavigate();
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [menuOpen, setOpenMenu] = React.useState(false);
    const colorMode = useContext(ColorModeContext);

    const theme = useTheme();

    React.useEffect(() => {
        const fetchUserInfo = () => {
            fetch(
                `${URL}/user?` + new URLSearchParams({ username: userName }),
                {
                    method: "GET",
                    mode: "cors",
                    credentials: "include",
                    headers: {
                        "content-type": "application/json",
                        Origin: `${origin}`,
                    },
                }
            )
                .then(async (response) => {
                    return {
                        data: await response.json(),
                        code: response.status,
                    };
                })
                .then((data) => {
                    if (data.code !== 200) {
                        navigate(`/${data.code}`);
                        throw new Error(data.data.message);
                    } else if (data.error) {
                        setError(data.error.message);
                    } else {
                        setUserInfo(data.data);
                    }
                });
        };
        fetchUserInfo();
    }, [userName, auth]);

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const logOut = (e) => {
        e.preventDefault();
        fetch(`${URL}/logout/`, {
            method: "POST",
            mode: "cors",
            credentials: "include",
            headers: {
                "content-type": "application/json",
                Origin: `${origin}`,
            },
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data.error) {
                    setError(data.error.message);
                }
                console.log(data);
                navigate("/");
            });
    };

    const handleProfilePage = () => {
        navigate("/profile");
        setOpenMenu(false);
    };

    const handleLinkPage = () => {
        navigate("link");
        setOpenMenu(false);
    };

    const closeAlert = () => {
        setError("");
    };

    const openMenu = () => {
        setOpenMenu(true);
    };

    const handleAboutPage = () => {
        navigate("about");
        setOpenMenu(false);
    };

    return (
        <>
            <AppBar
                position="static"
                style={{ backgroundColor: theme.palette.primary.dark }}
            >
                <Toolbar disableGutters sx={{ mx: 2, display: "flex" }}>
                    <IconButton onClick={openMenu}>
                        <MenuIcon
                            sx={{ color: theme.palette.primary.contrastText }}
                        />
                    </IconButton>
                    <Drawer
                        onClose={() => setOpenMenu(false)}
                        open={menuOpen}
                        anchor="left"
                        PaperProps={{
                            sx: { backgroundColor: theme.palette.primary.dark },
                        }}
                        variant="temporary"
                    >
                        <List
                            sx={{
                                width: 250,
                                "& .MuiListItemButton-root:hover": {
                                    bgcolor: "grey",
                                },
                            }}
                        >
                            <ListItem disablePadding>
                                <IconButton
                                    sx={{ marginLeft: 1 }}
                                    onClick={() => setOpenMenu(false)}
                                >
                                    <MenuIcon
                                        sx={{
                                            color: theme.palette.primary
                                                .contrastText,
                                        }}
                                    />
                                </IconButton>
                                <Box marginLeft={1.5}>
                                    <IconButton
                                        disableRipple
                                        onClick={() => {
                                            navigate("/dashboard");
                                            setOpenMenu(false);
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            noWrap
                                            sx={{
                                                fontWeight: "bold",
                                                marginRight: "0",
                                                color: theme.palette.primary
                                                    .contrastText,
                                            }}
                                        >
                                            Wealth
                                        </Typography>
                                        <Typography
                                            variant="h6"
                                            noWrap
                                            sx={{
                                                pr: 4,
                                                fontWeight: "bold",
                                                color: "rgba(0,255,149,1)",
                                            }}
                                        >
                                            Watch
                                        </Typography>
                                    </IconButton>
                                </Box>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton onClick={handleLinkPage}>
                                    <ListItemIcon>
                                        <LinkIcon
                                            sx={{
                                                color: theme.palette.primary
                                                    .contrastText,
                                            }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        sx={{
                                            color: theme.palette.primary
                                                .contrastText,
                                        }}
                                        primary="Link Platforms"
                                    />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton onClick={handleAboutPage}>
                                    <ListItemIcon>
                                        <InfoIcon
                                            sx={{
                                                color: theme.palette.primary
                                                    .contrastText,
                                            }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        sx={{
                                            color: theme.palette.primary
                                                .contrastText,
                                        }}
                                        primary="About us"
                                    />
                                </ListItemButton>
                            </ListItem>
                            <Divider sx={{ backgroundColor: "grey" }} />
                            <ListItem disablePadding>
                                <ListItemButton onClick={handleProfilePage}>
                                    <ListItemIcon>
                                        <AccountCircleIcon
                                            sx={{
                                                color: theme.palette.primary
                                                    .contrastText,
                                            }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        sx={{
                                            color: theme.palette.primary
                                                .contrastText,
                                        }}
                                        primary="Profile"
                                    />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton onClick={logOut}>
                                    <ListItemIcon>
                                        <LogoutIcon
                                            sx={{
                                                color: theme.palette.primary
                                                    .contrastText,
                                            }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        sx={{
                                            color: theme.palette.primary
                                                .contrastText,
                                        }}
                                        primary="Log out"
                                    />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </Drawer>

                    <IconButton
                        disableRipple
                        onClick={() => navigate("/dashboard")}
                        sx={{ minWidth: "fit-content" }}
                    >
                        <Typography
                            variant="h6"
                            noWrap
                            sx={{
                                mr: 2,
                                display: {},
                                fontWeight: "bold",
                                marginRight: "0",
                                color: theme.palette.primary.contrastText,
                            }}
                        >
                            Wealth
                        </Typography>
                        <Typography
                            variant="h6"
                            noWrap
                            sx={{
                                mr: 2,
                                display: {},
                                fontWeight: "bold",
                                color: "rgba(0,255,149,1)",
                            }}
                        >
                            Watch
                        </Typography>
                    </IconButton>
                    <Box
                        sx={{
                            flexGrow: 1,
                            display: {
                                display: "flex",
                                justifyContent: "flex-end",
                                marginRight: 10,
                            },
                        }}
                    >
                        <IconButton onClick={colorMode.toggleColorMode}>
                            {theme.palette.mode === "dark" ? (
                                <LightModeIcon />
                            ) : (
                                <DarkModeIcon />
                            )}
                        </IconButton>
                    </Box>

                    <Box sx={{ flexGrow: 0 }}>
                        <Tooltip title="Open settings">
                            <IconButton
                                onClick={handleOpenUserMenu}
                                sx={{ p: 0 }}
                            >
                                <Avatar
                                    sx={{ color: theme.palette.primary.light }}
                                    src={userInfo ? userInfo.imgurl : ""}
                                >
                                    {userInfo
                                        ? userInfo.username[0].toUpperCase()
                                        : ""}
                                </Avatar>
                            </IconButton>
                        </Tooltip>
                        <Menu
                            sx={{
                                "& .MuiMenu-paper": {
                                    backgroundColor: theme.palette.primary.dark,
                                },
                            }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            <MenuItem onClick={handleProfilePage}>
                                <Typography textAlign="center">
                                    Profile
                                </Typography>
                            </MenuItem>
                            <MenuItem onClick={logOut}>
                                <Typography textAlign="center">
                                    Logout
                                </Typography>
                            </MenuItem>
                        </Menu>
                    </Box>
                </Toolbar>
            </AppBar>
            <MessageModal
                severity="error"
                title="error"
                onClose={closeAlert}
                open={error ? true : false}
            >
                {error}
            </MessageModal>
        </>
    );
}
export default ResponsiveAppBar;
